<template>
  <v-menu v-model="languageMenu"
          :style="`min-width: ${$vuetify.breakpoint.xsOnly ? '80' : '120'}px`">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="text-capitalize" text v-bind="attrs" v-on="on">
        <span v-if="$vuetify.breakpoint.xsOnly"
              v-html="languages.find(item => item.value === locale).shortTitle"></span>
        <span v-else v-html="languages.find(item => item.value === locale).title"></span>
        <v-icon right small>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-for="(lang, index) in languages" :key="index" @click="handleMenuItemClick(lang)">
        <v-list-item-title>{{ lang.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {i18n} from "../../main"

export default {
  name: "FinLanguageSwitcher",
  data() {
    return {
      locale: 'de',
      languages: [
        {title: 'Deutsch', shortTitle: 'DE', value: 'de'},
        {title: 'English', shortTitle: 'EN', value: 'en'},
      ],
      languageMenu: false,
    }
  },
  methods: {
    handleMenuItemClick(lang) {
      this.locale = lang.value
      i18n.locale = this.locale
      //console.log("this.$i18n", this.$i18n)
    },
  },
}

</script>


<style lang="scss" scoped>

</style>
